module.exports = __webpack_public_path__ + "static/media/Logo_NativLab.100c2cf2.png";